module.exports = __webpack_public_path__ + "static/media/mobile-robots.f90770f0.gif";